/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  CreateSkillSharePathParameters,
  DeleteUserSkillPathParameters,
  ExportUserSkillZipPathParameters,
  GetSkillSharePathParameters,
  GetUserSkillContentPathParameters,
  GetUserSkillPathParameters,
  ImportUserSkillZipParams,
  ListUserSkillsParams,
  PromoteUserSkillToPlatformParams,
  PromoteUserSkillToPlatformPathParameters,
  PutUserSkillContentPathParameters,
  RevokeSkillSharePathParameters,
  TLAddSkillFromShareRequest,
  TLAddSkillFromShareResponse,
  TLCreateSkillShareRequest,
  TLCreateSkillShareResponse,
  TLHTTPValidationError,
  TLImportUserSkillZipRequest,
  TLPlatformSkillResponse,
  TLPreviewUserSkillZipImportRequest,
  TLSkillNormalizeRequest,
  TLSkillNormalizeResponse,
  TLSkillShareMetadataResponse,
  TLSuccessResponse,
  TLUserSkillContentPutRequest,
  TLUserSkillContentResponse,
  TLUserSkillCreateRequest,
  TLUserSkillResponse,
  TLUserSkillsListResponse,
  TLUserSkillUpdateRequest,
  UpdateUserSkillPathParameters,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List User Skills
 */
export const listUserSkills = (
  params?: ListUserSkillsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillsListResponse>({ url: `/user-skills`, method: 'GET', params, signal }, options);
};

export const getListUserSkillsQueryKey = (params?: ListUserSkillsParams) => {
  return ['user-skills', ...(params ? [params] : [])] as const;
};

export const getListUserSkillsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUserSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListUserSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUserSkillsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserSkills>>> = ({ signal }) =>
    listUserSkills(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUserSkills>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUserSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserSkills>>>;
export type ListUserSkillsQueryError = ErrorType<TLHTTPValidationError>;

export function useListUserSkills<
  TData = Awaited<ReturnType<typeof listUserSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params: undefined | ListUserSkillsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSkills>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserSkills>>,
          TError,
          Awaited<ReturnType<typeof listUserSkills>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUserSkills<
  TData = Awaited<ReturnType<typeof listUserSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListUserSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSkills>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserSkills>>,
          TError,
          Awaited<ReturnType<typeof listUserSkills>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUserSkills<
  TData = Awaited<ReturnType<typeof listUserSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListUserSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List User Skills
 */

export function useListUserSkills<
  TData = Awaited<ReturnType<typeof listUserSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListUserSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListUserSkillsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List User Skills
 */
export const prefetchListUserSkillsQuery = async <
  TData = Awaited<ReturnType<typeof listUserSkills>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  params?: ListUserSkillsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSkills>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListUserSkillsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List User Skills
 */
export const invalidateListUserSkills = async (
  queryClient: QueryClient,
  params?: ListUserSkillsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListUserSkillsQueryKey(params) }, options);

  return queryClient;
};

/**
 * @summary Create User Skill
 */
export const createUserSkill = (
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillResponse>(
    {
      url: `/user-skills`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLUserSkillCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateUserSkillQueryKey = (tLUserSkillCreateRequest?: BodyType<TLUserSkillCreateRequest>) => {
  return ['POST', 'user-skills', tLUserSkillCreateRequest] as const;
};

export const getCreateUserSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof createUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCreateUserSkillQueryKey(tLUserSkillCreateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createUserSkill>>> = ({ signal }) =>
    createUserSkill(tLUserSkillCreateRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof createUserSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateUserSkillQueryResult = NonNullable<Awaited<ReturnType<typeof createUserSkill>>>;
export type CreateUserSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useCreateUserSkill<
  TData = Awaited<ReturnType<typeof createUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createUserSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createUserSkill>>,
          TError,
          Awaited<ReturnType<typeof createUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateUserSkill<
  TData = Awaited<ReturnType<typeof createUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createUserSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createUserSkill>>,
          TError,
          Awaited<ReturnType<typeof createUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateUserSkill<
  TData = Awaited<ReturnType<typeof createUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create User Skill
 */

export function useCreateUserSkill<
  TData = Awaited<ReturnType<typeof createUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateUserSkillQueryOptions(tLUserSkillCreateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create User Skill
 */
export const prefetchCreateUserSkillQuery = async <
  TData = Awaited<ReturnType<typeof createUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCreateUserSkillQueryOptions(tLUserSkillCreateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create User Skill
 */
export const invalidateCreateUserSkill = async (
  queryClient: QueryClient,
  tLUserSkillCreateRequest: BodyType<TLUserSkillCreateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getCreateUserSkillQueryKey(tLUserSkillCreateRequest) }, options);

  return queryClient;
};

/**
 * Copy a shared skill into the caller's own library, in the current tenant.
 *
 * Tenant-scoped on purpose (unlike /shares/skills/resolve): creating the
 * UserSkills row requires an active tenant context from the X-Tenant-ID header.
 * @summary Add Skill From Share
 */
export const addSkillFromShare = (
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLAddSkillFromShareResponse>(
    {
      url: `/user-skills/add-from-share`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLAddSkillFromShareRequest,
      signal,
    },
    options,
  );
};

export const getAddSkillFromShareQueryKey = (tLAddSkillFromShareRequest?: BodyType<TLAddSkillFromShareRequest>) => {
  return ['POST', 'user-skills', 'add-from-share', tLAddSkillFromShareRequest] as const;
};

export const getAddSkillFromShareQueryOptions = <
  TData = Awaited<ReturnType<typeof addSkillFromShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addSkillFromShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddSkillFromShareQueryKey(tLAddSkillFromShareRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addSkillFromShare>>> = ({ signal }) =>
    addSkillFromShare(tLAddSkillFromShareRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof addSkillFromShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AddSkillFromShareQueryResult = NonNullable<Awaited<ReturnType<typeof addSkillFromShare>>>;
export type AddSkillFromShareQueryError = ErrorType<TLHTTPValidationError>;

export function useAddSkillFromShare<
  TData = Awaited<ReturnType<typeof addSkillFromShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof addSkillFromShare>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addSkillFromShare>>,
          TError,
          Awaited<ReturnType<typeof addSkillFromShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddSkillFromShare<
  TData = Awaited<ReturnType<typeof addSkillFromShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addSkillFromShare>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addSkillFromShare>>,
          TError,
          Awaited<ReturnType<typeof addSkillFromShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddSkillFromShare<
  TData = Awaited<ReturnType<typeof addSkillFromShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addSkillFromShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Add Skill From Share
 */

export function useAddSkillFromShare<
  TData = Awaited<ReturnType<typeof addSkillFromShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addSkillFromShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddSkillFromShareQueryOptions(tLAddSkillFromShareRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Add Skill From Share
 */
export const prefetchAddSkillFromShareQuery = async <
  TData = Awaited<ReturnType<typeof addSkillFromShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof addSkillFromShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getAddSkillFromShareQueryOptions(tLAddSkillFromShareRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Add Skill From Share
 */
export const invalidateAddSkillFromShare = async (
  queryClient: QueryClient,
  tLAddSkillFromShareRequest: BodyType<TLAddSkillFromShareRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getAddSkillFromShareQueryKey(tLAddSkillFromShareRequest) }, options);

  return queryClient;
};

/**
 * @summary Import User Skill Zip
 */
export const importUserSkillZip = (
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tLImportUserSkillZipRequest.file);

  return apiInstance<TLUserSkillResponse>(
    {
      url: `/user-skills/import`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
      signal,
    },
    options,
  );
};

export const getImportUserSkillZipQueryKey = (
  tLImportUserSkillZipRequest?: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
) => {
  return ['POST', 'user-skills', 'import', ...(params ? [params] : []), tLImportUserSkillZipRequest] as const;
};

export const getImportUserSkillZipQueryOptions = <
  TData = Awaited<ReturnType<typeof importUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getImportUserSkillZipQueryKey(tLImportUserSkillZipRequest, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof importUserSkillZip>>> = ({ signal }) =>
    importUserSkillZip(tLImportUserSkillZipRequest, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof importUserSkillZip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ImportUserSkillZipQueryResult = NonNullable<Awaited<ReturnType<typeof importUserSkillZip>>>;
export type ImportUserSkillZipQueryError = ErrorType<TLHTTPValidationError>;

export function useImportUserSkillZip<
  TData = Awaited<ReturnType<typeof importUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params: undefined | ImportUserSkillZipParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof importUserSkillZip>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importUserSkillZip>>,
          TError,
          Awaited<ReturnType<typeof importUserSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportUserSkillZip<
  TData = Awaited<ReturnType<typeof importUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importUserSkillZip>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importUserSkillZip>>,
          TError,
          Awaited<ReturnType<typeof importUserSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportUserSkillZip<
  TData = Awaited<ReturnType<typeof importUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import User Skill Zip
 */

export function useImportUserSkillZip<
  TData = Awaited<ReturnType<typeof importUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getImportUserSkillZipQueryOptions(tLImportUserSkillZipRequest, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Import User Skill Zip
 */
export const prefetchImportUserSkillZipQuery = async <
  TData = Awaited<ReturnType<typeof importUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getImportUserSkillZipQueryOptions(tLImportUserSkillZipRequest, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Import User Skill Zip
 */
export const invalidateImportUserSkillZip = async (
  queryClient: QueryClient,
  tLImportUserSkillZipRequest: BodyType<TLImportUserSkillZipRequest>,
  params?: ImportUserSkillZipParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getImportUserSkillZipQueryKey(tLImportUserSkillZipRequest, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary Preview User Skill Zip
 */
export const previewUserSkillZip = (
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tLPreviewUserSkillZipImportRequest.file);

  return apiInstance<TLSkillNormalizeResponse>(
    {
      url: `/user-skills/import/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPreviewUserSkillZipQueryKey = (
  tLPreviewUserSkillZipImportRequest?: BodyType<TLPreviewUserSkillZipImportRequest>,
) => {
  return ['POST', 'user-skills', 'import', 'preview', tLPreviewUserSkillZipImportRequest] as const;
};

export const getPreviewUserSkillZipQueryOptions = <
  TData = Awaited<ReturnType<typeof previewUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPreviewUserSkillZipQueryKey(tLPreviewUserSkillZipImportRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof previewUserSkillZip>>> = ({ signal }) =>
    previewUserSkillZip(tLPreviewUserSkillZipImportRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof previewUserSkillZip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PreviewUserSkillZipQueryResult = NonNullable<Awaited<ReturnType<typeof previewUserSkillZip>>>;
export type PreviewUserSkillZipQueryError = ErrorType<TLHTTPValidationError>;

export function usePreviewUserSkillZip<
  TData = Awaited<ReturnType<typeof previewUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewUserSkillZip>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewUserSkillZip>>,
          TError,
          Awaited<ReturnType<typeof previewUserSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePreviewUserSkillZip<
  TData = Awaited<ReturnType<typeof previewUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewUserSkillZip>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewUserSkillZip>>,
          TError,
          Awaited<ReturnType<typeof previewUserSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePreviewUserSkillZip<
  TData = Awaited<ReturnType<typeof previewUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Preview User Skill Zip
 */

export function usePreviewUserSkillZip<
  TData = Awaited<ReturnType<typeof previewUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPreviewUserSkillZipQueryOptions(tLPreviewUserSkillZipImportRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Preview User Skill Zip
 */
export const prefetchPreviewUserSkillZipQuery = async <
  TData = Awaited<ReturnType<typeof previewUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof previewUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPreviewUserSkillZipQueryOptions(tLPreviewUserSkillZipImportRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Preview User Skill Zip
 */
export const invalidatePreviewUserSkillZip = async (
  queryClient: QueryClient,
  tLPreviewUserSkillZipImportRequest: BodyType<TLPreviewUserSkillZipImportRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPreviewUserSkillZipQueryKey(tLPreviewUserSkillZipImportRequest) },
    options,
  );

  return queryClient;
};

/**
 * Repair arbitrary skill markdown into a canonical SKILL.md + extracted fields for the upload
 * preview; never rejects on format.
 * @summary Normalize Skill Markdown
 */
export const normalizeSkillMarkdown = (
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSkillNormalizeResponse>(
    {
      url: `/user-skills/normalize`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLSkillNormalizeRequest,
      signal,
    },
    options,
  );
};

export const getNormalizeSkillMarkdownQueryKey = (tLSkillNormalizeRequest?: BodyType<TLSkillNormalizeRequest>) => {
  return ['POST', 'user-skills', 'normalize', tLSkillNormalizeRequest] as const;
};

export const getNormalizeSkillMarkdownQueryOptions = <
  TData = Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof normalizeSkillMarkdown>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNormalizeSkillMarkdownQueryKey(tLSkillNormalizeRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof normalizeSkillMarkdown>>> = ({ signal }) =>
    normalizeSkillMarkdown(tLSkillNormalizeRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NormalizeSkillMarkdownQueryResult = NonNullable<Awaited<ReturnType<typeof normalizeSkillMarkdown>>>;
export type NormalizeSkillMarkdownQueryError = ErrorType<TLHTTPValidationError>;

export function useNormalizeSkillMarkdown<
  TData = Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof normalizeSkillMarkdown>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
          TError,
          Awaited<ReturnType<typeof normalizeSkillMarkdown>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNormalizeSkillMarkdown<
  TData = Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof normalizeSkillMarkdown>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
          TError,
          Awaited<ReturnType<typeof normalizeSkillMarkdown>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNormalizeSkillMarkdown<
  TData = Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof normalizeSkillMarkdown>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Normalize Skill Markdown
 */

export function useNormalizeSkillMarkdown<
  TData = Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof normalizeSkillMarkdown>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNormalizeSkillMarkdownQueryOptions(tLSkillNormalizeRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Normalize Skill Markdown
 */
export const prefetchNormalizeSkillMarkdownQuery = async <
  TData = Awaited<ReturnType<typeof normalizeSkillMarkdown>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof normalizeSkillMarkdown>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getNormalizeSkillMarkdownQueryOptions(tLSkillNormalizeRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Normalize Skill Markdown
 */
export const invalidateNormalizeSkillMarkdown = async (
  queryClient: QueryClient,
  tLSkillNormalizeRequest: BodyType<TLSkillNormalizeRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getNormalizeSkillMarkdownQueryKey(tLSkillNormalizeRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Delete User Skill
 */
export const deleteUserSkill = (
  { skillId }: DeleteUserSkillPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<void>({ url: `/user-skills/${skillId}`, method: 'DELETE', signal }, options);
};

export const getDeleteUserSkillQueryKey = ({ skillId }: DeleteUserSkillPathParameters) => {
  return ['DELETE', 'user-skills', skillId] as const;
};

export const getDeleteUserSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: DeleteUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDeleteUserSkillQueryKey({ skillId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteUserSkill>>> = ({ signal }) =>
    deleteUserSkill({ skillId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof deleteUserSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeleteUserSkillQueryResult = NonNullable<Awaited<ReturnType<typeof deleteUserSkill>>>;
export type DeleteUserSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useDeleteUserSkill<
  TData = Awaited<ReturnType<typeof deleteUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeleteUserSkillPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteUserSkill>>,
          TError,
          Awaited<ReturnType<typeof deleteUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteUserSkill<
  TData = Awaited<ReturnType<typeof deleteUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeleteUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteUserSkill>>,
          TError,
          Awaited<ReturnType<typeof deleteUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteUserSkill<
  TData = Awaited<ReturnType<typeof deleteUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeleteUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete User Skill
 */

export function useDeleteUserSkill<
  TData = Awaited<ReturnType<typeof deleteUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: DeleteUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteUserSkillQueryOptions({ skillId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Delete User Skill
 */
export const prefetchDeleteUserSkillQuery = async <
  TData = Awaited<ReturnType<typeof deleteUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: DeleteUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDeleteUserSkillQueryOptions({ skillId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Delete User Skill
 */
export const invalidateDeleteUserSkill = async (
  queryClient: QueryClient,
  { skillId }: DeleteUserSkillPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getDeleteUserSkillQueryKey({ skillId }) }, options);

  return queryClient;
};

/**
 * @summary Get User Skill
 */
export const getUserSkill = (
  { skillId }: GetUserSkillPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillResponse>({ url: `/user-skills/${skillId}`, method: 'GET', signal }, options);
};

export const getGetUserSkillQueryKey = ({ skillId }: GetUserSkillPathParameters) => {
  return ['user-skills', skillId] as const;
};

export const getGetUserSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: GetUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserSkillQueryKey({ skillId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSkill>>> = ({ signal }) =>
    getUserSkill({ skillId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserSkillQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSkill>>>;
export type GetUserSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useGetUserSkill<
  TData = Awaited<ReturnType<typeof getUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetUserSkillPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSkill>>,
          TError,
          Awaited<ReturnType<typeof getUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserSkill<
  TData = Awaited<ReturnType<typeof getUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSkill>>,
          TError,
          Awaited<ReturnType<typeof getUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserSkill<
  TData = Awaited<ReturnType<typeof getUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Skill
 */

export function useGetUserSkill<
  TData = Awaited<ReturnType<typeof getUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: GetUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserSkillQueryOptions({ skillId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Skill
 */
export const prefetchGetUserSkillQuery = async <
  TData = Awaited<ReturnType<typeof getUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: GetUserSkillPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetUserSkillQueryOptions({ skillId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get User Skill
 */
export const invalidateGetUserSkill = async (
  queryClient: QueryClient,
  { skillId }: GetUserSkillPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetUserSkillQueryKey({ skillId }) }, options);

  return queryClient;
};

/**
 * @summary Update User Skill
 */
export const updateUserSkill = (
  { skillId }: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillResponse>(
    {
      url: `/user-skills/${skillId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: tLUserSkillUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUpdateUserSkillQueryKey = (
  { skillId }: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest?: BodyType<TLUserSkillUpdateRequest>,
) => {
  return ['PATCH', 'user-skills', skillId, tLUserSkillUpdateRequest] as const;
};

export const getUpdateUserSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof updateUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUpdateUserSkillQueryKey({ skillId }, tLUserSkillUpdateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateUserSkill>>> = ({ signal }) =>
    updateUserSkill({ skillId }, tLUserSkillUpdateRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof updateUserSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UpdateUserSkillQueryResult = NonNullable<Awaited<ReturnType<typeof updateUserSkill>>>;
export type UpdateUserSkillQueryError = ErrorType<TLHTTPValidationError>;

export function useUpdateUserSkill<
  TData = Awaited<ReturnType<typeof updateUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUserSkill>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateUserSkill>>,
          TError,
          Awaited<ReturnType<typeof updateUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateUserSkill<
  TData = Awaited<ReturnType<typeof updateUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUserSkill>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateUserSkill>>,
          TError,
          Awaited<ReturnType<typeof updateUserSkill>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateUserSkill<
  TData = Awaited<ReturnType<typeof updateUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update User Skill
 */

export function useUpdateUserSkill<
  TData = Awaited<ReturnType<typeof updateUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateUserSkillQueryOptions({ skillId }, tLUserSkillUpdateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update User Skill
 */
export const prefetchUpdateUserSkillQuery = async <
  TData = Awaited<ReturnType<typeof updateUserSkill>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUserSkill>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getUpdateUserSkillQueryOptions({ skillId }, tLUserSkillUpdateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update User Skill
 */
export const invalidateUpdateUserSkill = async (
  queryClient: QueryClient,
  { skillId }: UpdateUserSkillPathParameters,
  tLUserSkillUpdateRequest: BodyType<TLUserSkillUpdateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getUpdateUserSkillQueryKey({ skillId }, tLUserSkillUpdateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get User Skill Content
 */
export const getUserSkillContent = (
  { skillId }: GetUserSkillContentPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillContentResponse>(
    { url: `/user-skills/${skillId}/content`, method: 'GET', signal },
    options,
  );
};

export const getGetUserSkillContentQueryKey = ({ skillId }: GetUserSkillContentPathParameters) => {
  return ['user-skills', skillId, 'content'] as const;
};

export const getGetUserSkillContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: GetUserSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserSkillContentQueryKey({ skillId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSkillContent>>> = ({ signal }) =>
    getUserSkillContent({ skillId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSkillContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserSkillContentQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSkillContent>>>;
export type GetUserSkillContentQueryError = ErrorType<TLHTTPValidationError>;

export function useGetUserSkillContent<
  TData = Awaited<ReturnType<typeof getUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetUserSkillContentPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkillContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSkillContent>>,
          TError,
          Awaited<ReturnType<typeof getUserSkillContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserSkillContent<
  TData = Awaited<ReturnType<typeof getUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetUserSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkillContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSkillContent>>,
          TError,
          Awaited<ReturnType<typeof getUserSkillContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserSkillContent<
  TData = Awaited<ReturnType<typeof getUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetUserSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Skill Content
 */

export function useGetUserSkillContent<
  TData = Awaited<ReturnType<typeof getUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: GetUserSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserSkillContentQueryOptions({ skillId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get User Skill Content
 */
export const prefetchGetUserSkillContentQuery = async <
  TData = Awaited<ReturnType<typeof getUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: GetUserSkillContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetUserSkillContentQueryOptions({ skillId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get User Skill Content
 */
export const invalidateGetUserSkillContent = async (
  queryClient: QueryClient,
  { skillId }: GetUserSkillContentPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetUserSkillContentQueryKey({ skillId }) }, options);

  return queryClient;
};

/**
 * @summary Put User Skill Content
 */
export const putUserSkillContent = (
  { skillId }: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillContentResponse>(
    {
      url: `/user-skills/${skillId}/content`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tLUserSkillContentPutRequest,
      signal,
    },
    options,
  );
};

export const getPutUserSkillContentQueryKey = (
  { skillId }: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest?: BodyType<TLUserSkillContentPutRequest>,
) => {
  return ['PUT', 'user-skills', skillId, 'content', tLUserSkillContentPutRequest] as const;
};

export const getPutUserSkillContentQueryOptions = <
  TData = Awaited<ReturnType<typeof putUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPutUserSkillContentQueryKey({ skillId }, tLUserSkillContentPutRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof putUserSkillContent>>> = ({ signal }) =>
    putUserSkillContent({ skillId }, tLUserSkillContentPutRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof putUserSkillContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PutUserSkillContentQueryResult = NonNullable<Awaited<ReturnType<typeof putUserSkillContent>>>;
export type PutUserSkillContentQueryError = ErrorType<TLHTTPValidationError>;

export function usePutUserSkillContent<
  TData = Awaited<ReturnType<typeof putUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof putUserSkillContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putUserSkillContent>>,
          TError,
          Awaited<ReturnType<typeof putUserSkillContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePutUserSkillContent<
  TData = Awaited<ReturnType<typeof putUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putUserSkillContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putUserSkillContent>>,
          TError,
          Awaited<ReturnType<typeof putUserSkillContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePutUserSkillContent<
  TData = Awaited<ReturnType<typeof putUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Put User Skill Content
 */

export function usePutUserSkillContent<
  TData = Awaited<ReturnType<typeof putUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPutUserSkillContentQueryOptions({ skillId }, tLUserSkillContentPutRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Put User Skill Content
 */
export const prefetchPutUserSkillContentQuery = async <
  TData = Awaited<ReturnType<typeof putUserSkillContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putUserSkillContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPutUserSkillContentQueryOptions({ skillId }, tLUserSkillContentPutRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Put User Skill Content
 */
export const invalidatePutUserSkillContent = async (
  queryClient: QueryClient,
  { skillId }: PutUserSkillContentPathParameters,
  tLUserSkillContentPutRequest: BodyType<TLUserSkillContentPutRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPutUserSkillContentQueryKey({ skillId }, tLUserSkillContentPutRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Export User Skill Zip
 */
export const exportUserSkillZip = (
  { skillId }: ExportUserSkillZipPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<unknown>({ url: `/user-skills/${skillId}/export`, method: 'GET', signal }, options);
};

export const getExportUserSkillZipQueryKey = ({ skillId }: ExportUserSkillZipPathParameters) => {
  return ['user-skills', skillId, 'export'] as const;
};

export const getExportUserSkillZipQueryOptions = <
  TData = Awaited<ReturnType<typeof exportUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: ExportUserSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportUserSkillZipQueryKey({ skillId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportUserSkillZip>>> = ({ signal }) =>
    exportUserSkillZip({ skillId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportUserSkillZip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportUserSkillZipQueryResult = NonNullable<Awaited<ReturnType<typeof exportUserSkillZip>>>;
export type ExportUserSkillZipQueryError = ErrorType<TLHTTPValidationError>;

export function useExportUserSkillZip<
  TData = Awaited<ReturnType<typeof exportUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportUserSkillZipPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserSkillZip>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportUserSkillZip>>,
          TError,
          Awaited<ReturnType<typeof exportUserSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportUserSkillZip<
  TData = Awaited<ReturnType<typeof exportUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportUserSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserSkillZip>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportUserSkillZip>>,
          TError,
          Awaited<ReturnType<typeof exportUserSkillZip>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportUserSkillZip<
  TData = Awaited<ReturnType<typeof exportUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportUserSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export User Skill Zip
 */

export function useExportUserSkillZip<
  TData = Awaited<ReturnType<typeof exportUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: ExportUserSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportUserSkillZipQueryOptions({ skillId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export User Skill Zip
 */
export const prefetchExportUserSkillZipQuery = async <
  TData = Awaited<ReturnType<typeof exportUserSkillZip>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: ExportUserSkillZipPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportUserSkillZip>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExportUserSkillZipQueryOptions({ skillId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Export User Skill Zip
 */
export const invalidateExportUserSkillZip = async (
  queryClient: QueryClient,
  { skillId }: ExportUserSkillZipPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getExportUserSkillZipQueryKey({ skillId }) }, options);

  return queryClient;
};

/**
 * @summary Promote User Skill To Platform
 */
export const promoteUserSkillToPlatform = (
  { skillId }: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPlatformSkillResponse>(
    { url: `/user-skills/${skillId}/promote`, method: 'POST', params, signal },
    options,
  );
};

export const getPromoteUserSkillToPlatformQueryKey = (
  { skillId }: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
) => {
  return ['POST', 'user-skills', skillId, 'promote', ...(params ? [params] : [])] as const;
};

export const getPromoteUserSkillToPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoteUserSkillToPlatformQueryKey({ skillId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>> = ({ signal }) =>
    promoteUserSkillToPlatform({ skillId }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PromoteUserSkillToPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>>;
export type PromoteUserSkillToPlatformQueryError = ErrorType<TLHTTPValidationError>;

export function usePromoteUserSkillToPlatform<
  TData = Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PromoteUserSkillToPlatformPathParameters,
  params: undefined | PromoteUserSkillToPlatformParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
          TError,
          Awaited<ReturnType<typeof promoteUserSkillToPlatform>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePromoteUserSkillToPlatform<
  TData = Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
          TError,
          Awaited<ReturnType<typeof promoteUserSkillToPlatform>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePromoteUserSkillToPlatform<
  TData = Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Promote User Skill To Platform
 */

export function usePromoteUserSkillToPlatform<
  TData = Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPromoteUserSkillToPlatformQueryOptions({ skillId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Promote User Skill To Platform
 */
export const prefetchPromoteUserSkillToPlatformQuery = async <
  TData = Awaited<ReturnType<typeof promoteUserSkillToPlatform>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteUserSkillToPlatform>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPromoteUserSkillToPlatformQueryOptions({ skillId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Promote User Skill To Platform
 */
export const invalidatePromoteUserSkillToPlatform = async (
  queryClient: QueryClient,
  { skillId }: PromoteUserSkillToPlatformPathParameters,
  params?: PromoteUserSkillToPlatformParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPromoteUserSkillToPlatformQueryKey({ skillId }, params) },
    options,
  );

  return queryClient;
};

/**
 * Metadata of the active share link for this skill (owner only).
 * @summary Get Skill Share
 */
export const getSkillShare = (
  { skillId }: GetSkillSharePathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSkillShareMetadataResponse>(
    { url: `/user-skills/${skillId}/share`, method: 'GET', signal },
    options,
  );
};

export const getGetSkillShareQueryKey = ({ skillId }: GetSkillSharePathParameters) => {
  return ['user-skills', skillId, 'share'] as const;
};

export const getGetSkillShareQueryOptions = <
  TData = Awaited<ReturnType<typeof getSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: GetSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSkillShareQueryKey({ skillId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSkillShare>>> = ({ signal }) =>
    getSkillShare({ skillId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSkillShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSkillShareQueryResult = NonNullable<Awaited<ReturnType<typeof getSkillShare>>>;
export type GetSkillShareQueryError = ErrorType<TLHTTPValidationError>;

export function useGetSkillShare<
  TData = Awaited<ReturnType<typeof getSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetSkillSharePathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillShare>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkillShare>>,
          TError,
          Awaited<ReturnType<typeof getSkillShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSkillShare<
  TData = Awaited<ReturnType<typeof getSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillShare>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkillShare>>,
          TError,
          Awaited<ReturnType<typeof getSkillShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSkillShare<
  TData = Awaited<ReturnType<typeof getSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Skill Share
 */

export function useGetSkillShare<
  TData = Awaited<ReturnType<typeof getSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: GetSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSkillShareQueryOptions({ skillId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Skill Share
 */
export const prefetchGetSkillShareQuery = async <
  TData = Awaited<ReturnType<typeof getSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: GetSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetSkillShareQueryOptions({ skillId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Skill Share
 */
export const invalidateGetSkillShare = async (
  queryClient: QueryClient,
  { skillId }: GetSkillSharePathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetSkillShareQueryKey({ skillId }) }, options);

  return queryClient;
};

/**
 * Freeze a snapshot of the skill and mint a share token (owner only).
 * Re-sharing revokes the previous link. The token is returned exactly once.
 * @summary Create Skill Share
 */
export const createSkillShare = (
  { skillId }: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLCreateSkillShareResponse>(
    {
      url: `/user-skills/${skillId}/share`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLCreateSkillShareRequest,
      signal,
    },
    options,
  );
};

export const getCreateSkillShareQueryKey = (
  { skillId }: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest?: BodyType<TLCreateSkillShareRequest>,
) => {
  return ['POST', 'user-skills', skillId, 'share', tLCreateSkillShareRequest] as const;
};

export const getCreateSkillShareQueryOptions = <
  TData = Awaited<ReturnType<typeof createSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCreateSkillShareQueryKey({ skillId }, tLCreateSkillShareRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createSkillShare>>> = ({ signal }) =>
    createSkillShare({ skillId }, tLCreateSkillShareRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof createSkillShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateSkillShareQueryResult = NonNullable<Awaited<ReturnType<typeof createSkillShare>>>;
export type CreateSkillShareQueryError = ErrorType<TLHTTPValidationError>;

export function useCreateSkillShare<
  TData = Awaited<ReturnType<typeof createSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSkillShare>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSkillShare>>,
          TError,
          Awaited<ReturnType<typeof createSkillShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateSkillShare<
  TData = Awaited<ReturnType<typeof createSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSkillShare>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSkillShare>>,
          TError,
          Awaited<ReturnType<typeof createSkillShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateSkillShare<
  TData = Awaited<ReturnType<typeof createSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create Skill Share
 */

export function useCreateSkillShare<
  TData = Awaited<ReturnType<typeof createSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateSkillShareQueryOptions({ skillId }, tLCreateSkillShareRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Skill Share
 */
export const prefetchCreateSkillShareQuery = async <
  TData = Awaited<ReturnType<typeof createSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCreateSkillShareQueryOptions({ skillId }, tLCreateSkillShareRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Skill Share
 */
export const invalidateCreateSkillShare = async (
  queryClient: QueryClient,
  { skillId }: CreateSkillSharePathParameters,
  tLCreateSkillShareRequest: BodyType<TLCreateSkillShareRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getCreateSkillShareQueryKey({ skillId }, tLCreateSkillShareRequest) },
    options,
  );

  return queryClient;
};

/**
 * Revoke the active share link for this skill (owner only).
 * @summary Revoke Skill Share
 */
export const revokeSkillShare = (
  { skillId }: RevokeSkillSharePathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSuccessResponse>(
    { url: `/user-skills/${skillId}/share/revoke`, method: 'POST', signal },
    options,
  );
};

export const getRevokeSkillShareQueryKey = ({ skillId }: RevokeSkillSharePathParameters) => {
  return ['POST', 'user-skills', skillId, 'share', 'revoke'] as const;
};

export const getRevokeSkillShareQueryOptions = <
  TData = Awaited<ReturnType<typeof revokeSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: RevokeSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRevokeSkillShareQueryKey({ skillId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof revokeSkillShare>>> = ({ signal }) =>
    revokeSkillShare({ skillId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof revokeSkillShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RevokeSkillShareQueryResult = NonNullable<Awaited<ReturnType<typeof revokeSkillShare>>>;
export type RevokeSkillShareQueryError = ErrorType<TLHTTPValidationError>;

export function useRevokeSkillShare<
  TData = Awaited<ReturnType<typeof revokeSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RevokeSkillSharePathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeSkillShare>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof revokeSkillShare>>,
          TError,
          Awaited<ReturnType<typeof revokeSkillShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRevokeSkillShare<
  TData = Awaited<ReturnType<typeof revokeSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RevokeSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeSkillShare>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof revokeSkillShare>>,
          TError,
          Awaited<ReturnType<typeof revokeSkillShare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRevokeSkillShare<
  TData = Awaited<ReturnType<typeof revokeSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RevokeSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Revoke Skill Share
 */

export function useRevokeSkillShare<
  TData = Awaited<ReturnType<typeof revokeSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { skillId }: RevokeSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRevokeSkillShareQueryOptions({ skillId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Revoke Skill Share
 */
export const prefetchRevokeSkillShareQuery = async <
  TData = Awaited<ReturnType<typeof revokeSkillShare>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { skillId }: RevokeSkillSharePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof revokeSkillShare>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getRevokeSkillShareQueryOptions({ skillId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Revoke Skill Share
 */
export const invalidateRevokeSkillShare = async (
  queryClient: QueryClient,
  { skillId }: RevokeSkillSharePathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getRevokeSkillShareQueryKey({ skillId }) }, options);

  return queryClient;
};
